import React, { useEffect, useRef, useState } from "react";
import { stats } from "../mock/mock";

const Counter = ({ target, suffix }) => {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !started.current) {
        started.current = true;
        const dur = 1400, start = performance.now();
        const tick = (now) => {
          const p = Math.min((now - start) / dur, 1);
          setVal(Math.floor((1 - Math.pow(1 - p, 3)) * target));
          if (p < 1) requestAnimationFrame(tick); else setVal(target);
        };
        requestAnimationFrame(tick);
      }
    }, { threshold: 0.4 });
    obs.observe(node);
    return () => obs.disconnect();
  }, [target]);
  return <span ref={ref}>{val}{suffix}</span>;
};

const Stats = () => {
  return (
    <section className="section-pad grid-dots border-b-2 border-[#0A0A0A]">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="eyebrow text-neutral-500">/ Who We Are</p>
            <h2 className="mt-4 display text-4xl md:text-5xl font-extrabold uppercase leading-[0.95]">
              Shaping Business With <span className="hl">Digital Transformation</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-neutral-700 leading-relaxed">
              A trusted digital transformation partner delivering software engineering across industries.
              With 650+ pre-vetted engineers, we optimize infrastructure, integrate systems, and maximize
              ROI for global enterprises — including Fortune 250 companies.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border-2 border-[#0A0A0A] bg-white">
          {stats.map((s, i) => (
            <div key={s.label} className={`p-7 border-[#0A0A0A] ${i % 6 !== 5 ? "lg:border-r-2" : ""} ${i < 3 ? "md:border-b-2 lg:border-b-0" : ""} border-b-2 md:border-b-0 ${i % 2 === 0 ? "border-r-2 md:border-r-0" : ""}`}>
              <p className="display text-4xl md:text-5xl font-extrabold stroke-text">
                <Counter target={s.value} suffix={s.suffix} />
              </p>
              <p className="mono text-[11px] uppercase tracking-widest text-neutral-500 mt-3">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
